import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/(no-auth)")({
	component: RouteComponent,
	validateSearch: z.object({
		redirectTo: z.string().optional(),
	}),
	loaderDeps: ({ search }) => [search.redirectTo],
	loader: async ({ deps, context: { session } }) => {
		if (session?.accessToken) {
			throw redirect({
				to: deps[0] || "/",
			});
		}
	},
});

function RouteComponent() {
	return <Outlet />;
}
